import { hasOlderLoadNotes } from 'store/loadNotes'
import { ClientOngoingLoad } from '@numeo/types-core'

/** Document updates and provider telemetry have independent clocks. */
export function mergeLoadUpdate(base: ClientOngoingLoad, update: Partial<ClientOngoingLoad>): ClientOngoingLoad {
    const merged = { ...base, ...update }
    if (update.notes === undefined || hasOlderLoadNotes(base, update)) {
        merged.notes = base.notes
        merged.notesRevision = base.notesRevision
    }
    const sourceTruckId = base.truckMotionSourceTruckId
    // An actual assignment change may legitimately supply an older reading from a different truck.
    if (!sourceTruckId || sourceTruckId !== base.truckId || merged.truckId !== base.truckId) return merged

    const baseTime = base.truckMotionLastUpdatedAt ? new Date(base.truckMotionLastUpdatedAt).getTime() : NaN
    if (!Number.isFinite(baseTime)) return merged
    const incomingTime = update.truckMotionLastUpdatedAt ? new Date(update.truckMotionLastUpdatedAt).getTime() : NaN
    const incomingSource = update.truckMotionSourceTruckId ?? update.truckId ?? base.truckId
    if (incomingSource === sourceTruckId && incomingTime >= baseTime) return merged

    // Preserve fresh motion without discarding legitimate changes to status, finance, route, etc.
    merged.vehicleMotionStatus = base.vehicleMotionStatus
    merged.truckMotionLastUpdatedAt = base.truckMotionLastUpdatedAt
    merged.truckMotionSourceTruckId = sourceTruckId
    if (merged.eta) {
        merged.eta = { ...merged.eta }
        delete merged.eta.vehicleMotionStatus
        if (base.eta?.vehicleMotionStatus) merged.eta.vehicleMotionStatus = base.eta.vehicleMotionStatus
    }
    return merged
}
